/** Picks the plural form of n for a language. */
export function plural(lang: string, n: number, forms: Partial<Record<Intl.LDMLPluralRule, string>> & { other: string }) {
  return forms[new Intl.PluralRules(lang).select(n)] ?? forms.other
}
